function getTitle(vm) {
  const { title } = vm.$options
  if (title) {
    return typeof title === 'function' ? title.call(vm) : title
  }
  return 'SAI360'
}
export default {
  created() {
    const title = getTitle(this)
    if (title) {
      document.title = title
    }
  },
  methods: {
    updateTitle(newTitle) {
      document.title = newTitle
    },
  },
}
